import axios from 'axios';
import Api from './Api';

import { dlt } from './Api';
const endpoint = 'transactions'

export const deleteTransaction = async id => await dlt(`${endpoint}/${id}`);

const { CancelToken } = axios;
let cancelRead;

class TransactionsApi extends Api {
  constructor() {
    super('transaction', 'transactions');
  }

  async getList(filters) {
    let list = [];
    const errorText = 'Could not fetch transactions list';

    try {
      list = await axios.post('/transactions', filters);
      if (list.status === 200) {
        list = list.data;
      } else {
        console.error(errorText);
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      list = [];
    }

    return list;
  }

  async getCurrentLevels() {
    let list = [];
    const errorText = 'Could not fetch current levels';

    try {
      list = await axios.get('/transactions/current_levels');
      if (list.status === 200) {
        list = list.data;
      } else {
        console.error(errorText);
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      list = [];
    }

    return list;
  }

  async getCurrentLevel(
    inventoryItemId,
    manufacturerId,
    materialPropertyId,
    lengthId,
    colorId,
    finishingId,
    uomId,
  ) {
    let res = 0;
    const errorText = 'Could not fetch current level';
    const props = {
      inventory_item_id: inventoryItemId,
      manufacturer_id: manufacturerId,
      material_property_id: materialPropertyId,
      length_id: lengthId,
      color_id: colorId,
      finishing_id: finishingId,
      uom_id: uomId,
    };

    try {
      res = await axios.post('/transactions/current_level', props);
      if (res.status === 200) {
        res = res.data;
      } else {
        console.error(errorText);
      }
    } catch (e) {
      console.error(errorText);
      console.error(e);
      res = 0;
    }

    return res;
  }

  async readLevels(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    }, 'read/levels');
    return res;
  }

  async readTransactions(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const transactionsApi = new TransactionsApi();

export default transactionsApi;
